// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-not-found-container 
{
  width: 40%; 
  flex-direction: column;
  background-color: var(--secondary-color);
  border-radius: 10px;
  padding: 30px 20px;
  display: flex;
  align-items: center;
  color: white;
  text-align: center;
  position: absolute;
  left: 50%;
  top: 35%;
  transform: translate(-50%, -50%);
  margin-top: 40px;
  min-width: 500px;
}

.not-found-heading 
{
  font-size: clamp(1.2rem, 3vw, 2rem);
  margin-bottom: 20px;
}
  
.not-found-message 
{
  font-size: clamp(0.8rem, 2vw, 1.2rem);
  margin-bottom: 20px;
}
  
.not-found-code 
{
  font-family: monospace;
  padding: 5px 5px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.go-back-from-not-found 
{
  background-color: var(--accent-color);
  color: var(--secondary-color);
  padding: 10px 30px;
  border-radius: 20px;
  font-size: 20px;
  font-weight: 500;
  margin-top : 20px;
  margin-bottom : 20px;
  transition: 300ms ease;
}

.go-back-from-not-found:hover
{
  background-color: var(--dark-secondary-color);
  color: white;
}
  
.not-found-link 
{
  text-decoration: none;
}
  

  @media only screen and (max-width: 850px) 
  {
    .page-not-found-container
    {
      width: 90%; 
      max-width: 400px; 
      margin-top: 50px;
      min-width: 100px;
    }

    .go-back-from-not-found
    {
      font-size: 15px;
      padding: 8px 25px;
    }
}
  `, "",{"version":3,"sources":["webpack://./src/components/NotFound.css"],"names":[],"mappings":"AAAA;;EAEE,UAAU;EACV,sBAAsB;EACtB,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;;EAEE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,qCAAqC;EACrC,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;EAEE,6CAA6C;EAC7C,YAAY;AACd;;AAEA;;EAEE,qBAAqB;AACvB;;;EAGE;;IAEE;;MAEE,UAAU;MACV,gBAAgB;MAChB,gBAAgB;MAChB,gBAAgB;IAClB;;IAEA;;MAEE,eAAe;MACf,iBAAiB;IACnB;AACJ","sourcesContent":[".page-not-found-container \n{\n  width: 40%; \n  flex-direction: column;\n  background-color: var(--secondary-color);\n  border-radius: 10px;\n  padding: 30px 20px;\n  display: flex;\n  align-items: center;\n  color: white;\n  text-align: center;\n  position: absolute;\n  left: 50%;\n  top: 35%;\n  transform: translate(-50%, -50%);\n  margin-top: 40px;\n  min-width: 500px;\n}\n\n.not-found-heading \n{\n  font-size: clamp(1.2rem, 3vw, 2rem);\n  margin-bottom: 20px;\n}\n  \n.not-found-message \n{\n  font-size: clamp(0.8rem, 2vw, 1.2rem);\n  margin-bottom: 20px;\n}\n  \n.not-found-code \n{\n  font-family: monospace;\n  padding: 5px 5px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n.go-back-from-not-found \n{\n  background-color: var(--accent-color);\n  color: var(--secondary-color);\n  padding: 10px 30px;\n  border-radius: 20px;\n  font-size: 20px;\n  font-weight: 500;\n  margin-top : 20px;\n  margin-bottom : 20px;\n  transition: 300ms ease;\n}\n\n.go-back-from-not-found:hover\n{\n  background-color: var(--dark-secondary-color);\n  color: white;\n}\n  \n.not-found-link \n{\n  text-decoration: none;\n}\n  \n\n  @media only screen and (max-width: 850px) \n  {\n    .page-not-found-container\n    {\n      width: 90%; \n      max-width: 400px; \n      margin-top: 50px;\n      min-width: 100px;\n    }\n\n    .go-back-from-not-found\n    {\n      font-size: 15px;\n      padding: 8px 25px;\n    }\n}\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
